import Checkbox from "common/components/ui/Checkbox";
import Label from "common/components/ui/Label";
import useAppStore from "common/hooks/useAppStore";

export default function MiscOptions() {
  const {
    shouldDebugLogin,
    workspacePermissions,
    isWithoutSubscription,
    isWithoutRentedSubscription,
    isWithoutAccounts,
  } = useAppStore((state) => state.debugOptions);
  const isPaymentMethodHidden = useAppStore(
    (state) => state.debugOptions.isPaymentMethodHidden,
  );

  return (
    <>
      <span className="mb-2 text-xs text-black-400">Misc. Options</span>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="debugLogin"
          size="sm"
          checked={shouldDebugLogin}
          onCheckedChange={(checked: boolean) =>
            useAppStore
              .getState()
              .setDebugOptions({ shouldDebugLogin: checked })
          }
        />
        <Label htmlFor="debugLogin" size="sm">
          Debug Login
        </Label>
      </div>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="paymentMethodHidden"
          size="sm"
          checked={isPaymentMethodHidden}
          onCheckedChange={(checked: boolean) =>
            useAppStore
              .getState()
              .setDebugOptions({ isPaymentMethodHidden: checked })
          }
        />
        <Label htmlFor="paymentMethodHidden" size="sm">
          No Payment method
        </Label>
      </div>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="subscriptionHidden"
          size="sm"
          checked={isWithoutSubscription}
          onCheckedChange={(checked: boolean) =>
            useAppStore.getState().setDebugOptions({
              isWithoutSubscription: checked,
              subscriptionStatus: null,
            })
          }
        />
        <Label htmlFor="subscriptionHidden" size="sm">
          No Subscription
        </Label>
      </div>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="rentedSubscriptionHidden"
          size="sm"
          checked={isWithoutRentedSubscription}
          onCheckedChange={(checked: boolean) =>
            useAppStore.getState().setDebugOptions({
              isWithoutRentedSubscription: checked,
              rentedSubscriptionStatus: null,
            })
          }
        />
        <Label htmlFor="rentedSubscriptionHidden" size="sm">
          No Rented Subscription
        </Label>
      </div>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="noAccounts"
          size="sm"
          checked={isWithoutAccounts}
          onCheckedChange={(checked: boolean) =>
            useAppStore.getState().setDebugOptions({
              isWithoutAccounts: checked,
            })
          }
        />
        <Label htmlFor="noAccounts" size="sm">
          No Accounts
        </Label>
      </div>
      <div className="flex flex-row items-center gap-1">
        <Checkbox
          id="workspacePermissions"
          size="sm"
          checked={!!workspacePermissions}
          onCheckedChange={(checked: boolean) =>
            useAppStore.getState().setDebugOptions({
              workspacePermissions: checked
                ? [
                    "campaigns_full",
                    "leads_full",
                    "inbox_full",
                    "accounts_full",
                    "templates_full",
                    "members_full",
                    "billing_full",
                    "integrations_full",
                    "public_api_full",
                    "webhooks_full",
                  ]
                : null,
            })
          }
        />
        <Label htmlFor="workspacePermissions" size="sm">
          Override Permissions
        </Label>
      </div>
    </>
  );
}
